import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sh-typography',
  templateUrl: './typography.component.html',
  styleUrl: './typography.component.scss',
  standalone: false
})
export class TypographyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
